import React from 'react';
import { FormattedNumber } from 'react-intl';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';

export const mapping = {
  brand: '000000000000000000000001',
  model: '000000000000000000000002',
  power: '59b119db29b1d60028469f9d',
  firstRegistration: '59c3855229b1d6037f5f0e71',
  mileage: '59b1167929b1d6002703e4c5',
  gearbox: '59b0194029b1d600142386c7',
  fuelType: '59b015f929b1d6001423869b',
  capacity: '59b11c0529b1d60028469fa5',
  paintColor: '5950e06ae3f1310d0347c0a1',
  paintColorManufacturer: '59b1164129b1d60028469f99',
  carType: '59afe9fa29b1d6000874e1d1',
  numPreviousOwner: '59b11c9e29b1d60028469fa9',
  emissionClass: '59b014ee29b1d600151f5855',
  numDoors: '59b013db29b1d60014238691',
  carCondition: '59b1158129b1d6002703e4c1',
  numSeats: '59b11a9329b1d600265622f9',
  constructionYear: '59b11ab829b1d60028469fa1',
  parkingAssistance: '59c4d6f329b1d600813fecd4',
  interiorMaterial: '59b01dec29b1d600171161cd',
  airbags: '59b25bc329b1d6017a38e8b1',
  airConditioning: '59b01ab829b1d600142386cb',
  environmentBadge: '5a60a27847ce0d01fc059a91',
  co2Emissions: '59c5381329b1d6013031dee9',
  fuelConsumptionCombined: '59c514f829b1d601314beb11',
  fuelConsumptionUrban: '59c5154e29b1d6012f6c6491',
  fuelConsumptionExtraUrban: '59c515f529b1d6013031dee1',
  energyEfficiencyClass: '59c518e729b1d6013031dee5',
};

export const energyEfficiencyClassColorMap = {
  A: '#00984C',
  B: '#4FAD45',
  C: '#C6D42E',
  D: '#FEED01',
  E: '#F8B80F',
  F: '#EB6724',
  G: '#E21E26',
};

export const energyLabels = [
  { label: 'A+', color: '#00a650' },
  { label: 'A', color: '#00a650' },
  { label: 'B', color: '#4db748' },
  { label: 'C', color: '#c0d434' },
  { label: 'D', color: '#fdf300' },
  { label: 'E', color: '#ffb80e' },
  { label: 'F', color: '#f37022' },
  { label: 'G', color: '#ed1b24' },
];

export const carCategories = [
  '0000000006',
  '0000000007',
  '0000000008',
  '0000000009',
  '000000000A',
  '000000000B',
  '000000000C',
  '000000000D',
  '000000000E',
  '000000000F',
  '000000000G',
  '000000000H',
];

export const categories = {
  passengerVehicles: '0000000006',
  passengerVehiclesPath: ',0,0000000006,',
};

export const carIcons = {
  'Mercedes-Benz': 'mercedes',
  Audi: 'audi',
  BMW: 'bmw',
  Ford: 'ford',
  FORD: 'ford',
  Hyundai: 'hyundai',
  Jaguar: 'jaguar',
  JEEP: 'jeep',
  Jeep: 'jeep',
  'Land-Rover': 'land-rover',
  'Land Rover': 'land-rover',
  MAN: 'man',
  Mini: 'mini',
  Peugeot: 'peugeot',
  Renault: 'renault',
  Scania: 'scania',
  Seat: 'seat',
  SEAT: 'seat',
  Skoda: 'skoda',
  smart: 'smart',
  Volkswagen: 'volkswagen',
  VW: 'volkswagen',
  Volvo: 'volvo',
  Mitsubishi: 'mitsubishi',
  PORSCHE: 'porsche',
  Porsche: 'porsche',
  Suzuki: 'suzuki',
  SUZUKI: 'suzuki',
  DS: 'ds',
  Citroen: 'citroen',
  CITROEN: 'citroen',
  Microcar: 'microcar',
  MICROCAR: 'microcar',
};

export const typeIcons = {
  '59afeb1329b1d60009144831': 'chedri-cabrio-car',
  '59afeb1329b1d60009144835': 'chedri-sedan-car-model',
  '59afeb1329b1d60009144839': 'chedri-car-suv',
  '59afeb1329b1d6000914483d': 'chedri-jeep',
  '59afeb1329b1d60009144841': 'chedri-car-city-model',
  '59afec4529b1d60009144845': 'chedri-sportive-car',
  '59afec4529b1d60009144849': 'chedri-minivan-car',
};

export const equipmentLevels = messages => {
  return [
    {
      name: messages.equipment_level_budget,
      value: 'budget',
      description: [`${messages.radio}, ${messages.airConditioning}`],
    },
    {
      name: messages.equipment_level_family,
      value: 'family',
      description: [`${messages.equipment_level_budget} +`, `Bluetooth, ${messages.parkingAssistanceRear}`],
    },
    {
      name: messages.equipment_level_comfort,
      value: 'comfort',
      description: [
        `${messages.equipment_level_family} +`,
        `${messages.airConditioningAutomatic}, ${messages.navigation}, ${messages.alloyRims}, ${messages.parkingAssistanceFrontRear}`,
      ],
    },
    {
      name: messages.equipment_level_business,
      value: 'business',
      description: [
        `${messages.equipment_level_comfort} +`,
        `${messages.metallicPaint}, ${messages.cruiseControl}, ${messages.seatHeating}, ${messages.leatherSeats}`,
      ],
    },
  ];
};

export const getDefaultImage = item => {
  let defaultImage;

  if (item.default_img) {
    defaultImage = item.default_img;
  }

  return defaultImage;
};

export const getFileVariation = (image, variationType) => {
  let variationFile;

  if (image) {
    _.forEach(image.variations, variation => {
      if (variation.variation_type === variationType) {
        variationFile = variation.file;
      }
    });
  }

  return variationFile;
};

export const getThumbFile = image => {
  return getFileVariation(image, 'thumb');
};

export const getWebFile = image => {
  return getFileVariation(image, 'web');
};

export const getXlFile = image => {
  return getFileVariation(image, 'xl');
};

export const getRetinaFile = image => {
  return getFileVariation(image, 'retina');
};

export const getDefaultImageFromEntity = item => {
  return item.getDefaultImg();
};

export const getFileVariationFromEntity = (image, variationType) => {
  let variationFile;

  _.forEach(image.getVariations(), variation => {
    if (variation.getVariationType() === variationType) {
      variationFile = variation.getFile();
    }
  });

  return variationFile;
};

export const getThumbFileFromEntity = image => {
  return getFileVariationFromEntity(image, 'thumb');
};

export const getWebFileFromEntity = image => {
  return getFileVariationFromEntity(image, 'web');
};

export const getXlFileFromEntity = image => {
  return getFileVariationFromEntity(image, 'xl');
};

export const getRetinaFileFromEntity = image => {
  return getFileVariationFromEntity(image, 'retina');
};

export const getAttributeSingleValue = (item, appIntl, attributeId) => {
  const attribute = _.find(item.attributes, ['id', attributeId]);

  if (attribute && attribute.values && attribute.values[0]) {
    return getNameInCurrentLanguage(attribute.values[0].value, appIntl);
  }

  return null;
};

export const getAttributeValues = (item, appIntl, attributeId) => {
  const attribute = _.find(item.attributes, ['id', attributeId]);

  const values = [];
  if (attribute) {
    attribute.values.map(attr => {
      if (attr) values.push(getNameInCurrentLanguage(attr.value, appIntl));
    });
  }
  return values;
};

export const getAttributeName = (item, appIntl, attributeId) => {
  const attribute = _.find(item.attributes, ['id', attributeId]);
  if (attribute) {
    return getNameInCurrentLanguage(attribute.name, appIntl);
  }
};

export const getName = (item, key) => {
  return key in item ? item[key].name : '';
};

export const getBrand = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.brand);
};

export const getModel = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.model);
};

export const getPower = (item, appIntl) => {
  // power in kW
  return getAttributeSingleValue(item, appIntl, mapping.power);
};

export const kWToPSRatio = 1.35962;

export const getHorsePower = kWPower => {
  return Math.round(kWPower * 1.35962);
};

export const getCapacity = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.capacity);
};

export const getPaintColor = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.paintColor);
};

export const getPaintColorHex = item => {
  const attribute = _.find(item.attributes, ['id', mapping.paintColor]);

  if (attribute) {
    return attribute.values[0].color;
  }
};

export const getPaintColorManufacturer = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.paintColorManufacturer);
};

export const getFirstRegistration = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.firstRegistration);
};

export const getMileage = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.mileage);
};

export const getGearbox = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.gearbox);
};

export const getFuelType = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.fuelType);
};

export const getCarType = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.carType);
};

export const getNumberPreviousCarOwner = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.numPreviousOwner);
};

export const getEmissionClass = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.emissionClass);
};

export const getNumberDoors = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.numDoors);
};

export const getCarCondition = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.carCondition);
};

export const getNumberSeats = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.numSeats);
};

export const getConstructionYear = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.constructionYear);
};

export const getParkingAssistance = (item, appIntl) => {
  return getAttributeValues(item, appIntl, mapping.parkingAssistance).join(', ');
};

export const getInteriorMaterial = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.interiorMaterial);
};

export const getAirbags = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.parkingAssistance);
};

export const getAirConditioning = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.airConditioning);
};

export const getEnvironmentBadge = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.environmentBadge);
};

export const getCo2Emissions = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.co2Emissions);
};

export const getFuelConsumptionCombined = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.fuelConsumptionCombined);
};

export const getFuelConsumptionUrban = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.fuelConsumptionUrban);
};

export const getFuelConsumptionExtraUrban = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.fuelConsumptionExtraUrban);
};

export const getEnergyEfficiencyClass = (item, appIntl) => {
  return getAttributeSingleValue(item, appIntl, mapping.energyEfficiencyClass);
};

export const getCategoryFromPath = categoryPath => {
  return categoryPath.substring(3, categoryPath.indexOf(',', 4));
};

export const getSearchTypeFromCategoryPath = categoryPath => {
  const category = getCategoryFromPath(categoryPath);
  return getSearchTypeFromCategory(category);
};

export const getSearchTypeFromCategory = category => {
  if (carCategories.indexOf(category) > -1) {
    return 'cars';
  }

  return 'summary';
};

// check if the item is inside any of car categories (passenger, commercial, vans, ...)
export const isCarItem = item => {
  for (let i = 0; i < carCategories.length; i++) {
    if (item.category_path.indexOf(`,0,${carCategories[i]}`) === 0) {
      return true;
    }
  }

  return false;
};

// display item price
export const displayItemPrice = (intl, projectConfig, item) => {
  if (item.min_price || item.max_price) {
    if (item.max_price && item.max_price > item.min_price) {
      if (isCarItem(item)) {
        return (
          <span>
            {intl.messages.from}{' '}
            <FormattedNumber value={item.min_price} style="currency" currency={projectConfig.data.currency} />
          </span>
        );
      }
      return (
        <span>
          <FormattedNumber value={item.min_price} style="currency" currency={projectConfig.data.currency} />
          &nbsp;-&nbsp;
          <FormattedNumber value={item.max_price} style="currency" currency={projectConfig.data.currency} />
        </span>
      );
    }
    return <FormattedNumber value={item.min_price} style="currency" currency={projectConfig.data.currency} />;
  }
  return intl.messages.price;
};

// check if selected item is one of the user's favorite
export const isInFavorites = (favorites, item) => {
  for (let i = 0; i < favorites.length; i++) {
    if (favorites[i].item.id === item.id) {
      return true;
    }
  }

  return false;
};

// check how many days will be calculated when renting a car
export const getCarRentalDaysCount = (dateFrom, dateTo) => {
  const start = moment(dateFrom);
  const end = moment(dateTo);
  const duration = moment.duration(end.diff(start));

  return Math.ceil(duration.asDays());
};

// get car rental prices
// if the prices are missing, calculate them on the fly
export const getCarRentalPrices = item => {
  return {
    weekdayPrice: item.pricing.weekday_price,
    weekendPrice: item.pricing.weekend_price || Math.ceil(item.pricing.weekday_price * 1.8) - 1,
    weekPrice: item.pricing.week_price || Math.ceil(item.pricing.weekday_price * 4.2) - 1,
    monthPrice: item.pricing.month_price || Math.ceil(item.pricing.weekday_price * 11) - 1,
  };
};

export const calculateCarRentalPeriodsCount = (daysCount = 0, dateFrom = null, dateTo = null) => {
  let weekdayCount = 0;
  let weekendCount = 0;
  let weekCount = 0;
  let monthCount = 0;
  let date = moment(dateFrom);

  const startTz = moment.tz(dateFrom, 'UTC').tz('Europe/Berlin');
  const startTime = startTz.hours() + startTz.minutes() / 60;
  const endTz = moment.tz(dateTo, 'UTC').tz('Europe/Berlin');
  const endTime = endTz.hours() + endTz.minutes() / 60;

  if (daysCount < 7) {
    for (let i = 0; i < daysCount; i++) {
      if (date.isoWeekday() === 5 && daysCount - (i + 2) >= 0) {
        // friday; check if the rental ends now or continues till after the weekend
        weekendCount++;

        // check if the booking starts before the weekend rate (12:00)
        // if yes, calculate additional day
        if (startTime < 12) {
          weekdayCount++;
          i++;
          date = date.add(1, 'days');
        }

        date = date.add(2, 'days');
        i += 2;

        // check if the booking ends before or after 12:00
        if (endTime > 12) {
          weekdayCount++;
          i++;
          date = date.add(1, 'days');
        }
      } else {
        // weekday
        weekdayCount++;

        date = date.add(1, 'days');
      }
    }
  } else if (daysCount < 30) {
    // calculate for how many weeks the car is rented
    weekCount = Math.round((daysCount / 7) * 100) / 100;
  } else {
    // calculate for how many months the car is rented
    monthCount = Math.round((daysCount / 30) * 100) / 100;
  }

  return {
    weekdayCount,
    weekendCount,
    weekCount,
    monthCount,
    quantity: weekdayCount + weekendCount + weekCount + monthCount,
  };
};

// calculate car rental price
export const calculateCarRentalPrice = (item, daysCount = 0, dateFrom = null, dateTo = null) => {
  const { weekdayPrice, weekendPrice, weekPrice, monthPrice } = getCarRentalPrices(item);
  const { weekdayCount, weekendCount, weekCount, monthCount, quantity } = calculateCarRentalPeriodsCount(
    daysCount,
    dateFrom,
    dateTo
  );

  const totalWeekday = weekdayCount * weekdayPrice;
  const totalWeekend = weekendCount * weekendPrice;
  const totalWeek = weekCount * weekPrice;
  const totalMonth = monthCount * monthPrice;

  return {
    weekdayPrice,
    weekendPrice,
    weekPrice,
    monthPrice,
    totalWeekday,
    totalWeekend,
    totalWeek,
    totalMonth,
    weekdayCount,
    weekendCount,
    weekCount,
    monthCount,
    total: totalWeekday + totalWeekend + totalWeek + totalMonth,
    quantity,
  };
};

export const getAllowedCarRentalMileageByDaysCountAndStartDate = (daysCount = 0, dateFrom = null, dateTo = null) => {
  const { weekdayCount, weekendCount, weekCount, monthCount } = calculateCarRentalPeriodsCount(
    daysCount,
    dateFrom,
    dateTo
  );

  return weekdayCount * 250 + weekendCount * 750 + weekCount * 1500 + monthCount * 3500;
};

// get maximal milaege the user could drive when renting a car
export const getAllowedCarRentalMileage = orders => {
  let allowedMileage = 0;

  for (let i = 0; i < orders.length; i++) {
    for (let j = 0; j < orders[i].items.length; j++) {
      switch (orders[i].items[j].code) {
        case 'RENTAL_WEEKDAY':
          allowedMileage += 250 * orders[i].items[j].quantity;
          break;

        case 'RENTAL_WEEKEND':
          allowedMileage += 750 * orders[i].items[j].quantity;
          break;

        case 'RENTAL_WEEK':
          allowedMileage += 1500 * orders[i].items[j].quantity;
          break;

        case 'RENTAL_MONTH':
          allowedMileage += 3500 * orders[i].items[j].quantity;
          break;
      }
    }
  }

  return allowedMileage;
};

// get amount in euro for how much is one extra kilometer charged (car rental)
export const getCarRentalMileageSurcharge = carRentalWeekdayPrice => {
  if (carRentalWeekdayPrice < 50) {
    return 0.25;
  }
  if (carRentalWeekdayPrice < 80) {
    return 0.3;
  }
  if (carRentalWeekdayPrice < 100) {
    return 0.35;
  }
  if (carRentalWeekdayPrice < 120) {
    return 0.4;
  }
  if (carRentalWeekdayPrice < 170) {
    return 0.45;
  }
  return 0.5;
};

// check if selected date is within opening hours
export const checkOpeningHours = (workingHours, selectedDate) => {
  // workingHours.iso_day1, iso_day2, iso_day3, iso_day4, iso_day5, iso_day6, iso_day7
  const date = moment(selectedDate);

  const isoWeekday = date.isoWeekday();
  const hours = date.hours();
  const minutes = date.minutes();

  const daySettings =
    workingHours && workingHours[`iso_day${isoWeekday}`] ? workingHours[`iso_day${isoWeekday}`] : null;

  if (daySettings) {
    const floatTime = parseFloat(hours + minutes / 60);

    for (let i = 0; i < daySettings.length; i++) {
      if (daySettings[i].start <= floatTime && daySettings[i].end >= floatTime) {
        // return true if any of the time periods contains the searched date
        return true;
      }
    }
  }

  return false;
};

export const getAdditionalCosts = (
  { lead, car, hasDamages, fuelLevel, tankVolume, mileage, previousMileage },
  { messages }
) => {
  const allowedRentalMileage = getAllowedCarRentalMileage(lead.orders);
  const costs = {
    fuelLevel: fuelLevel < 100,
    mileage: mileage - previousMileage > allowedRentalMileage,
    damage: hasDamages,
    positions: [],
    total: 0,
  };

  if (costs.fuelLevel) {
    const quantity = Math.ceil((tankVolume * (100 - fuelLevel)) / 100);

    costs.positions.push({
      group: 'FUELING_COSTS',
      name: messages.vehicle_fuel_costs,
      quantity,
      grossPrice: 1.6,
      price: quantity * 1.6,
      quantityUnit: 'liter',
      quantityUnitName: messages.uom.liter,
      quantityUnitSymbole: messages.uom_symbole.liter,
    });

    costs.total += quantity * 1.6;
  }

  if (costs.mileage) {
    const quantity = Math.round(mileage - previousMileage - allowedRentalMileage);
    const grossPrice = getCarRentalMileageSurcharge(car.pricing.weekday_price);

    costs.positions.push({
      group: 'MILEAGE_SURCHARGE',
      name: messages.mileage_surcharge,
      quantity,
      grossPrice,
      price: quantity * grossPrice,
      quantityUnit: 'kilometer',
      quantityUnitName: messages.uom.kilometer,
      quantityUnitSymbole: messages.uom_symbole.kilometer,
    });

    costs.total += quantity * grossPrice;
  }

  if (costs.damage) {
    const grossPrice = 1000;

    costs.positions.push({
      group: 'INSURANCE_SELF_PARTICIPATION',
      name: messages.insurance_self_participation,
      quantity: 1,
      grossPrice,
      price: 1 * grossPrice,
      quantityUnit: 'piece',
      quantityUnitName: messages.uom.piece,
      quantityUnitSymbole: messages.uom_symbole.piece,
    });

    costs.total += 1 * grossPrice;
  }

  return costs;
};

export function getModelList(carModels) {
  const models = getCarSingleModels(carModels);
  const groups = getCarModelGroups(carModels);

  return _.sortBy(_.concat(models, groups), ['name']);
}

export function getCarSingleModels(carModels) {
  return carModels
    .filter(model => !model.group_id)
    .map(model => ({
      id: model.id,
      brandId: model.brand_id,
      filterName: 'MODEL',
      name: model.name,
      src: model.assets ? model.assets[0] : null,
      icon: model.assets ? null : 'car-side',
    }));
}

export function getCarModelGroups(carModels) {
  return _.uniqBy(
    carModels
      .filter(model => model.group_id && model.group_name)
      .map(model => ({
        id: model.group_id,
        brandId: model.brand_id,
        filterName: 'MODEL_GROUP',
        name: model.group_name,
        src: model.assets ? model.assets[0] : null,
        icon: model.assets ? null : 'car-side',
      })),
    'name'
  );
}

export function filterOutModelsWithBrands(selectedModelNames, brandNames, brands, models) {
  return (selectedModelNames || []).filter(modelName => {
    const model = _.find(models, { name: modelName });
    const brand = _.find(brands, { id: model.brand_id });

    return !brandNames.includes(brand.name);
  });
}

export function filterOutModelGroupsWithBrands(selectedModelNames, brandNames, brands, models) {
  return (selectedModelNames || []).filter(modelName => {
    const model = _.find(models, { group_name: modelName });
    const brand = _.find(brands, { id: model.brand_id });

    return !brandNames.includes(brand.name);
  });
}

export function getCarRentQueryParams({ fromDate, endDate, region, category, filters }) {
  let params = {
    category,
    'filters[type]': 'car',
    'filters[isResource]': true,
  };

  if (fromDate) {
    const reservationDateFrom = moment(fromDate || new Date())
      .utc()
      .format('YYYY-MM-DD hh:mm');
    const reservationDateTo = moment(endDate)
      .utc()
      .format('YYYY-MM-DD hh:mm');

    params = {
      ...params,
      reservationDateFrom,
      reservationDateTo,
      'filter[dateFrom]': reservationDateFrom,
      'filter[dateTo]': reservationDateTo,
    };
  }

  if (region) {
    const bounds = [
      region.longitude - region.longitudeDelta / 2,
      region.latitude - region.latitudeDelta / 2,
      region.longitude + region.longitudeDelta / 2,
      region.latitude + region.latitudeDelta / 2,
    ];

    params = {
      ...params,
      boundsNW: [bounds[1], bounds[0]].join(','),
      boundsSE: [bounds[3], bounds[2]].join(','),
    };
  }

  return {
    ...params,
    ...(filters || {}),
  };
}

export function getBrandLogoUlr(assetLocationUrl, brand, checked) {
  return `${assetLocationUrl}/img/brands/${carIcons[brand.name]}${checked ? '' : '_grey'}_small.png`;
}

export function removeItemImage(item, imgObject) {
  return {
    ...item,
    assets: {
      ...item.assets,
      imgs: item.assets.imgs.filter(img => img.id !== imgObject.id),
    },
  };
}
const getCurrentTranslationObj = (translations, appIntl) => {
  let translation = _.find(translations, { lang: appIntl.displayIntlForm });

  if (!translation) {
    translation = _.find(translations, { lang: appIntl.mainLanguage || null || undefined });
  }

  if (!translation) {
    [translation] = translations;
  }

  return translation;
};

const getNameInCurrentLanguage = (translations, appIntl) => {
  const translation = getCurrentTranslationObj(translations, appIntl);

  return translation ? translation.name : null;
};
